const ja = {
  meta: { code: "ja", label: "日本語" },
  nav: {
    brand: "IQ Log",
    diagnostics: "診断カタログ",
    mypage: "マイページ",
    login: "ログイン",
    register: "登録",
    logout: "ログアウト",
  },
  hero: {
    eyebrow: "診断プラットフォーム",
    title: "診断でわかる、あなたの本質",
    subtitle1: "思考・性格・適性を、すべて可視化",
    subtitle2: "5分で、あなたの強みと弱点が見える",
    subtitle3: "すべての診断が、あなたのデータになる",
    cta_primary: "診断を始める",
    cta_secondary: "カタログを見る",
    disclaimer: "参考情報 / 非医療",
  },
  categories: {
    ability: "能力系",
    personality: "性格系",
    mental: "メンタル系",
    aptitude: "適性系",
    traits: "特性分析",
  },
  catalog: {
    title: "すべての診断",
    subtitle: "17種類 / 全カテゴリ",
    filter_all: "すべて",
    duration: "分",
    difficulty: { easy: "初級", medium: "中級", hard: "上級" },
    question_count: "問",
    start: "診断を始める",
  },
  quiz: {
    question: "設問",
    of: "/",
    next: "次へ",
    prev: "戻る",
    submit: "結果を見る",
    progress: "進捗",
    exit: "中断して戻る",
    required: "選択肢を選んでください",
    submitting: "採点中…",
  },
  result: {
    overall: "総合スコア",
    type_label: "タイプ",
    share_link: "このリンクで結果を共有",
    back_to_catalog: "他の診断を受ける",
    view_mypage: "マイページで履歴を見る",
    premium_title: "詳細分析を解放する",
    premium_subtitle: "有料版で次の内容をすべて確認できます",
    feature_breakdown: "詳細スコア分解",
    feature_cause: "原因分析",
    feature_plan: "改善プラン",
    feature_pdf: "PDFレポート（A4）",
    price: "¥980",
    price_note: "（Stripeで安全に決済）",
    price_free: "無料",
    price_free_note: "（期間限定 / 完全無料）",
    unlock_button: "Stripeで決済する",
    unlock_button_free: "無料で解放する",
    unlock_requires_auth: "ログイン後に解放できます",
    unlock_save_first: "まずはアカウントで結果を保存してください",
    unlocking: "Stripe決済画面へ移動中…",
    free_only_notice: "無料版では概要スコアとタイプのみ表示されます",
    compliance_note:
      "この診断は参考情報であり、医療診断ではありません。断定的・不安を煽る表現は行いません。",
  },
  premium: {
    title: "詳細分析レポート",
    summary: "総合所見",
    strengths: "強み",
    weaknesses: "伸びしろ",
    improvements: "改善提案",
    dimensions: "次元別スコア",
    download_pdf: "PDFをダウンロード",
    pdf_soon: "PDF出力（近日実装）",
  },
  mypage: {
    title: "マイページ",
    subtitle: "あなたの診断履歴・スコア推移・獲得バッジ",
    total: "診断数",
    average: "平均スコア",
    premium_count: "解放済み",
    categories_covered: "達成カテゴリ",
    trend_title: "スコア推移",
    history_title: "診断履歴",
    badges_title: "獲得バッジ",
    unlock_3_title: "総合分析を解放",
    unlock_3_desc: "あと {n} 診断で、あなただけの総合分析が解放されます",
    unlocked: "総合分析が解放されました",
    no_history: "まだ診断を受けていません。最初の診断を始めましょう。",
  },
  auth: {
    login_title: "ログイン",
    register_title: "アカウント登録",
    email: "メールアドレス",
    password: "パスワード（6文字以上）",
    name: "表示名（任意）",
    login_btn: "ログイン",
    register_btn: "登録する",
    go_register: "新規登録はこちら",
    go_login: "すでにアカウントをお持ちの方",
    anon_note: "診断自体は匿名で受けられます。結果の保存・課金にはアカウントが必要です。",
    success_register: "登録が完了しました",
    success_login: "ログインしました",
    consent_section: "同意事項",
    consent_required: "必須項目に同意してください",
    accept_terms_pre: "",
    terms_link: "利用規約",
    accept_terms_post: "に同意します",
    accept_privacy_pre: "",
    privacy_link: "プライバシーポリシー",
    accept_privacy_post: "に同意し、個人データの取扱いを理解しました",
    accept_age: "私は16歳以上であり、必要な場合は法定代理人の同意を得ています",
    accept_marketing: "新着診断・キャンペーン情報をメールで受け取る",
    optional: "任意",
  },
  landing: {
    status_online: "SYSTEM ONLINE",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "17 TESTS",
    status_langs: "14 LANGS",
    status_ai: "AI · ON",
    title_line1: "診断でわかる、",
    title_line2: "あなたの本質。",
    trust_diagnostics: "診断数",
    trust_languages: "対応言語",
    trust_per_test: "1テスト",
    hud_readout: "プライマリ計測値",
    hud_score_unit: "/100 総合",
    hud_band: "バンド · GOLD",
    hud_dimensions: "次元",
    hud_dimensions_status: "3 / 3 アクティブ",
    hud_syslog: "システムログ",
    cat_eyebrow: "// カテゴリー",
    cat_title_pre: "5 カテゴリ · ",
    cat_title_highlight: "17 診断",
    view_all: "すべて見る",
    proto_eyebrow: "// プロトコル",
    proto_title_pre: "3 ステップで ",
    proto_title_highlight: "本質を解放。",
    step1_title: "診断を選ぶ",
    step1_body: "17種類から興味のあるものを選択。匿名でOK。",
    step2_title: "5分で回答",
    step2_body: "進捗バー＋バッジ獲得でモチベを後押し。",
    step3_title: "AIで解放",
    step3_body: "詳細スコア・改善プラン・PDFを取得。",
    final_eyebrow: "// 準備はOK?",
    final_title_pre: "あなたの本質を、",
    final_title_highlight: "5分で。",
    final_subtitle: "5分で、あなたの強みと弱点が見える",
    final_button: "今すぐ診断を始める",
  },
  footer: {
    tagline: "思考・性格・適性を記録する診断プラットフォーム",
    rights: "All rights reserved.",
    legal: "法的情報",
    privacy: "プライバシー",
    terms: "利用規約",
    about_label: "運営会社",
    compliance_label: "国際コンプライアンス",
    tokushoho_label: "特定商取引法に基づく表記",
    data_protection_label: "データ保護（国際対応・完全版）",
    data_request_label: "データ削除・オプトアウト申請",
    disclaimer_label: "免責事項",
    disclaimer_full:
      "本サービスは医療行為ではなく、参考情報の提供を目的としています。断定的な表現や不安を煽る表現は行いません。",
  },
  badges: {
    "first-diagnosis": "ファースト診断",
    "three-diagnostics": "3診断達成",
    "five-diagnostics": "5診断達成",
    "ten-diagnostics": "10診断達成",
    "high-performer": "ハイパフォーマー",
    "premium-user": "プレミアムユーザー",
  },
  lang_selector: "言語",
  payment: {
    processing_title: "決済を確認中…",
    processing_subtitle: "Stripeから戻りました。詳細分析を生成しています（最大20秒）",
    success: "決済完了 — 詳細分析が解放されました",
    expired: "決済セッションが期限切れになりました。もう一度お試しください。",
    error: "決済確認に失敗しました。サポートまでお問い合わせください。",
  },
};

export default ja;
